import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	applicationLinksTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	unknownErrorText: {
		defaultMessage: string;
		id: string;
		description: string;
	};
} = defineMessages({
	applicationLinksTitle: {
		defaultMessage: 'Application links',
		id: 'applinks.administration.ui.application-links-title',
		description: 'Title for the application links section',
	},
	unknownErrorText: {
		defaultMessage: 'We encountered an unknown error.',
		id: 'applinks.administration.ui.unknown-error',
		description:
			'A generic error message for when something goes wrong, but without any further detail.',
	},
});
export default messages;
